module.exports = "/assets/sero-logo.svg";